define('views/parts/modal/modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'src/plugins/bootbox.extension',
    // views
    'src/views/responsive-view'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    Bootbox,
    // views
    VResponsive
) {

    var VModal = VResponsive.extend({
        className: 'clearfix',
        modal: {
            onEscape: false,
            /**
             * undefined/null - The backdrop is displayed, but clicking on it has no effect.
             * true - The backdrop is displayed, and clicking on it dismisses the dialog.
             * false - The backdrop is not displayed.
             * @type {Boolean}
             */
            backdrop: true,
            size: "large",
            className: "fade",
            closeButton: true,
        },
        buttons: _.identity,

        renderModal: function() {
            var modalOptions = _.result(this, 'modal'),
                modal = _.extend({
                        message: this.el,
                        // callback: this.onConfirm,
                        context: this,
                        buttons: this.buttons({
                            cancel: {
                                label: i18n.t("Cancel"),
                                callback: this.onCancel,
                            },
                            confirm: {
                                label: i18n.t("Ok"),
                                callback: this.onConfirm,
                            },
                        }),
                    },
                    VModal.prototype.modal,
                    modalOptions, {
                        animate: false
                    }
                );

            if (modalOptions.animate !== false) modal.className = (modal.className || "") + " modal-animation";

            var $modal = this.$modal = Bootbox.dialog(modal)
                .on('show.bs.modal', this.onShow.bind(this))
                .on('hide.bs.modal', this.onHide.bind(this))
                .on('hidden.bs.modal', this.onHidden.bind(this));
            _.defer(this._onShown.bind(this));

            this.$backdrop = $modal.data('bs.modal').$backdrop;

            U.hideIntercom();

            return this;
        },

        close: function() {
            this.$modal.modal('hide');
            U.showIntercom();
        },

        ////////////
        // events //
        ////////////
        onCancel: function() {
            this.close();
        },
        onShow: _.noop,
        onShown: _.noop,
        _onShown: function() {
            this.$modal.removeClass('modal-animation').addClass('fade');
            var $backdrop = this.$backdrop;
            if ($backdrop) $backdrop.addClass('fade');
            this.onShown();
        },
        onHide: _.noop,
        onHidden: _.noop,
        onConfirm: _.noop,
    });

    return VModal;

});

